import Action from '../Action'
import './styles/ModalDeleteUSer.css'
import { useState } from 'react';
import LoadSimple from '../LoadSimple';
import { lang } from '../generales/traduction';
import { capitalizeFirstLetter } from '../../utils/utils';
const ModalDeleteUSer =({languaje,mode,user,closDeleteUserModal,setData,setLoading,setError,server})=>{
    const [loadingM,setLoadingM]=useState(false);
    const Eliminar=()=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/users/'+user.user_id, {
             method: 'DELETE',  
             headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoadingM(false)
             // Manejo de la respuesta
             setData(data1)
             closDeleteUserModal()
             // console.log(data1);
           } else {
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
            // Manejo de errores
            setError(error)
            console.error(error);
          }
        };

        fetchDataPost();
    }
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs delete-modal-gs'>
                            {/* <div className='head-card-users delete-modal'>
                                <div className='title-head-card-users'>
                                   ELIMINAR USUARIO
                                </div>
                            </div> */}
                            <div className='content-card-modal-gs'>
                                <div className='cont-info-modal-delete-gs'>
                                    <div className='cont-message-modal-delete-gs'>
                                            <div className='txt-message-modal-delete-gs'>
                                                {capitalizeFirstLetter(lang[languaje]['eliminar'])+" "+capitalizeFirstLetter(lang[languaje]['usuario'])}:
                                            </div>
                                    </div>
                                    <div className='cont-user-modal-delete-gs'>
                                            <div className='txt-user-modal-delete-gs'>
                                                {user.name}
                                            </div>
                                    </div>
                                    <div className='cont-btn-modal-delete-gs'>
                                            {
                                                (loadingM)?<LoadSimple></LoadSimple>:
                                                <>
                                                <Action  disabled={false} origen='Red' titulo={capitalizeFirstLetter(lang[languaje]['eliminar'])}  action={Eliminar}></Action>
                                            <Action  disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closDeleteUserModal}></Action>
                                                </>
                                            }
                                    </div>
                                </div>
                            </div>
            </div>
        </div>
    )
}

export default ModalDeleteUSer